// extracted by css-extract-rspack-plugin
export default {"table":"haQxw","collectionLink":"GF7_J"};